<template>
  <div>
      <span v-for="item in catalog" :key="item">
          {{item}}
      </span>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import * as wizardTypes from '../../store/wizard/types';

export default {
    computed: {
        ...mapGetters({
            catalog: wizardTypes.GETTERS.GET_CATALOG
        })
    },
    methods:{
        ...mapActions({
            retrieveCatalog: wizardTypes.ACTIONS.RETRIEVE_CATALOG
        })
    },
    created(){
        this.retrieveCatalog(['1','2','3'])
    }


}
</script>

<style>

</style>